import { useState } from "react";
import { useTranslation } from "@i18n/hooks";
import {
	formWrapperClass,
	textCenterClass,
	dividerWrapperClass,
	dividerLineClass,
} from "./login-options.styles";
import { type LoginOptionsProps } from "./login-options.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { SocialLogin, OneTimePasswordLogin, PasswordLogin } from "../../../../components/logins";
import { H1Span } from "../../../../themes/font-tags";

export const LoginOptions = ({
	headerText,
	onSubmit,
	onGoToForgotPassword,
	isLoading,
}: LoginOptionsProps) => {
	const { t } = useTranslation("common");
	const [usePassword, setUsePassword] = useState(false);

	const handleToggleLoginOptionsOnClick = () => setUsePassword(!usePassword);
	const toggleLoginOptionsLabel = usePassword
		? t("login.signInWithEmail")
		: t("login.signInWithPassword");

	return (
		<div className={formWrapperClass}>
			<div className={textCenterClass}>{headerText && <H1Span>{headerText}</H1Span>}</div>
			<SocialLogin />
			<div className={dividerWrapperClass}>
				<div className={dividerLineClass} />
				<span>{t("login.or")}</span>
				<div className={dividerLineClass} />
			</div>
			{usePassword ? (
				<PasswordLogin
					onSubmit={(values) => onSubmit?.(values)}
					onGoToForgotPassword={onGoToForgotPassword}
					isLoading={isLoading}
				/>
			) : (
				<OneTimePasswordLogin />
			)}
			<Button
				variant={ButtonVariant.Textlink}
				label={toggleLoginOptionsLabel}
				onClick={handleToggleLoginOptionsOnClick}
				disabled={isLoading}
			/>
		</div>
	);
};
